import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=2d0a7ce6&scoped=true"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"
import style0 from "./SearchSection.vue?vue&type=style&index=0&id=2d0a7ce6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a7ce6",
  null
  
)

export default component.exports